import { semanticColors } from '@/theme/tokens';

/**
 * Shared VoteMate Switch styling — a compact 36×20 pill toggle.
 *
 * Colors: textPrimary (rockSlate) is the default "on" track color; brandAccent
 * (logoPurple) is the highlight (checked-hover) color. Used by the Settings
 * toggles and the ballot status popup's auto-save toggle so both read identically.
 */
export const TOGGLE_SX = {
  width: 36,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '2px',
    transitionDuration: '200ms',
    '&:hover': { backgroundColor: 'transparent' },
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& .MuiSwitch-thumb': {
        backgroundColor: semanticColors.textOnPrimary,
      },
      '& + .MuiSwitch-track': {
        backgroundColor: semanticColors.textPrimary,
        borderColor: 'transparent',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
    backgroundColor: semanticColors.textTertiary,
    boxShadow: 'none',
    transition: 'background-color 200ms',
  },
  '& .MuiSwitch-track': {
    borderRadius: 10,
    backgroundColor: 'transparent',
    // textPlaceholder (#767676) clears the 3:1 non-text-contrast bar on white
    // so the off-state control boundary stays perceivable (border #BDBDBD did not).
    border: `1.5px solid ${semanticColors.textPlaceholder}`,
    opacity: '1 !important',
    transition: 'background-color 200ms, border-color 200ms',
    boxSizing: 'border-box',
  },
  '&:hover .MuiSwitch-switchBase:not(.Mui-checked) + .MuiSwitch-track': {
    backgroundColor: semanticColors.overlaySubtle,
  },
  '&:hover .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: semanticColors.brandAccent,
  },
  '& .MuiTouchRipple-root': { display: 'none' },
} as const;
